/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'
import { Spin } from 'antd'
import styled from 'styled-components'


interface Props {
  isLoading?: boolean;
}

export default class Content extends React.Component<Props> {
  render() {
    const { children } = this.props

    return (
      <ContentContainer>
        {children}
        {this.renderLoading()}
      </ContentContainer>
    )
  }

  renderLoading () {
    const { isLoading } = this.props

    if (isLoading) {
      return (
        <SpinWrapper>
          <Spin/>
        </SpinWrapper>
      )
    }
  }
}

const ContentContainer = styled.div`
  position: relative;
  padding: 24px 20px;
  background: #fff;
  min-height: 280px !important;
  max-width: 900px;
  margin: 24px auto;
`

const SpinWrapper = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 99;
`
